import { REGEX } from '@lessonPlanner/regex';

export const sanitize = (input: string): string => {
  return input.replace(REGEX.SANITIZE_ID, '');
};
